import React, { useState } from 'react';
import {
  Box,
  Chip,
  TextField,
  Typography,
} from '@mui/material';

const TagSelector = ({ label, tags = [], onChange, predefined = [] }) => {
  const [customInput, setCustomInput] = useState('');

  const handleTogglePredefined = (tag) => {
    if (tags.includes(tag)) {
      onChange(tags.filter((t) => t !== tag));
    } else {
      onChange([...tags, tag]);
    }
  };

  const handleAddCustom = (e) => {
    if (e.key === 'Enter' && customInput.trim()) {
      e.preventDefault();
      const newTag = customInput.trim().toLowerCase();
      if (!tags.includes(newTag)) {
        onChange([...tags, newTag]);
      }
      setCustomInput('');
    }
  };

  const handleDeleteTag = (tag) => {
    onChange(tags.filter((t) => t !== tag));
  };

  const customTags = tags.filter((t) => !predefined.includes(t));

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
        {predefined.map((tag) => (
          <Chip
            key={tag}
            label={tag.replace(/_/g, ' ')}
            variant={tags.includes(tag) ? 'filled' : 'outlined'}
            color={tags.includes(tag) ? 'primary' : 'default'}
            onClick={() => handleTogglePredefined(tag)}
            size="small"
          />
        ))}
      </Box>
      {customTags.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
          {customTags.map((tag) => (
            <Chip
              key={tag}
              label={tag}
              color="secondary"
              size="small"
              onDelete={() => handleDeleteTag(tag)}
            />
          ))}
        </Box>
      )}
      <TextField
        size="small"
        placeholder="Add custom tag (Enter to add)"
        value={customInput}
        onChange={(e) => setCustomInput(e.target.value)}
        onKeyDown={handleAddCustom}
        fullWidth
        sx={{ mt: 1 }}
      />
    </Box>
  );
};

export default TagSelector;
